import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CollegePortalJobsService } from '../../../../college-workspace/services/college-portal-jobs.service';
import { CollegeJobDetail } from '../../../../college-workspace/models/college-jobs.models';

@Component({
  selector: 'app-job-detail-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './job-detail-modal.component.html',
  styleUrl: './job-detail-modal.component.scss'
})
export class JobDetailModalComponent implements OnChanges {
  @Input() jobId!: string;
  @Output() close = new EventEmitter<void>();

  job: CollegeJobDetail | null = null;
  isLoading = false;

  constructor(
    private jobsService: CollegePortalJobsService,
    private toastr: ToastrService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['jobId'] && this.jobId) {
      this.loadDetail();
    }
  }

  private loadDetail(): void {
    this.isLoading = true;
    this.job = null;
    this.jobsService.getJobDetail(this.jobId).pipe(
      finalize(() => { this.isLoading = false; })
    ).subscribe({
      next: (res) => {
        if (res.Success) {
          this.job = res.Data;
        } else {
          this.toastr.error(res.Message || 'Failed to load job details.');
          this.close.emit();
        }
      },
      error: (err) => {
        this.toastr.error(err?.error?.Message || 'Failed to load job details.');
        this.close.emit();
      }
    });
  }
}
